import _defineProperty from "E:/wnmp/www/ycf_m/static/mmm-cli/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es6.function.name";
import "vant/es/loading/style";
import _Loading from "vant/es/loading";
export default {
  name: 'Loading',
  components: _defineProperty({}, _Loading.name, _Loading),
  data: function data() {
    return {
      message: "",
      color: "#B5741E"
    };
  },
  mounted: function mounted() {},
  methods: {}
};